import { API_URL } from '../config';
import { makeApiCall } from '../_common/api.utils';

// Create Section
export const createSection = async (data: any) => {
	const requestData = {
		CreateSectionToken: data,
	};
	const URL = `${API_URL}CreateSection`;
	return makeApiCall(URL, requestData);
};

// Update Section
export const updateSection = async (data: any) => {
	const requestData = {
		UpdateSectionToken: data,
	};
	const URL = `${API_URL}UpdateSection`;
	return makeApiCall(URL, requestData);
};

// Get Sections By Organisation
export const getSectionsByOrganisation = async (data: any) => {
	const requestData = {
		SectionDetailsToken: data,
	};
	const URL = `${API_URL}GetSectionsByOrganisation`;
	return makeApiCall(URL, requestData);
};
